export const sdkVersion = `unleash-client-js:__VERSION__`;
